import { idSchemaV2, isId } from '../ids'
import { z } from 'zod'

export const PrizeIdSchema = idSchemaV2('Prize')
export type PrizeId = z.infer<typeof PrizeIdSchema>
export const isPrizeId = isId(PrizeIdSchema)

export const GamePrizeSchema = z.object({
  name: z.string(),
  prizeId: PrizeIdSchema,
  download: z.string().optional(),
  url: z.optional(z.url().or(z.literal(''))),
  description: z.string().optional(),
})
export type GamePrize = z.infer<typeof GamePrizeSchema>

export const GameAwardSchema = z.object({
  place: z.number(),
  type: z.enum(['pick', 'all']).optional(),
  prizes: z.array(GamePrizeSchema),
})
export type GameAward = z.infer<typeof GameAwardSchema>

export type GamePrizeInfo = {
  titles: string[]
  imageUrls: string[]
}
